<template>
  <common-dialog
    ref="dialog"
    title="Send Email"
    :width="50"
    :save-cb="sendMail"
    ok-text="Send Email"
  >
    <template v-slot:content>
      <div v-loading="sendingMail">
        <div
          class="f-r recipient-container"
          v-for="(input, index) in emailInputs"
          :key="'emial-input-' + index"
        >
          <div class="title f-c">
            <span>{{ input.title }}</span>
            <span style="min-height: 30px;"></span>
          </div>
          <div class="emails f-r">
            <el-tag
              class="email-tag"
              :key="index + '-' + email"
              v-for="email in input.emails"
              closable
              :disable-transitions="false"
              @close="emailRemove(email, input)"
            >
              {{ email }}
            </el-tag>
            <div class="f-c" v-if="input.showEmailInput">
              <el-input
                v-model="input.emailInput"
                :ref="input.inputRef"
                clearable
                size="small"
                @keyup.enter.native="emailInputConfirm(input)"
                @blur="emailInputConfirm(input)"
                @input="input.showErrMsg = false"
              />
              <span v-if="input.showErrMsg" class="input-error">
                {{ input.errMsg }}
              </span>
            </div>
            <el-button class="new-but f-c-c-c" @click="emailInputShow(input)">
              <svg-icon
                icon-class="close"
                style="font-size: 16px;"
                class="svg-danger-color"
                v-if="input.showEmailInput"
              />
              <svg-icon
                icon-class="plus"
                style="font-size: 18px;"
                class="svg-business-color"
                v-else
              />
            </el-button>
          </div>
        </div>
        <div class="subject f-r">
          <span class="title">Subject: </span>
          <el-input size="small" v-model="mailSubject"></el-input>
        </div>
        <vue-editor class="content" v-model="mailContent" />
      </div>
    </template>
  </common-dialog>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { promisify } from '@/core/utils/common'
export default {
  name: 'SendEmailDialog',
  components: {
    CommonDialog,
    VueEditor
  },
  data() {
    return {
      sendCb: null,
      emailReg:
        /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
      mailContent: undefined,
      mailSubject: undefined,
      sendingMail: false,
      emailInputs: [
        {
          title: 'Recipients: ',
          inputRef: 'inputOne',
          emails: [],
          errMsg: '',
          showErrMsg: false,
          emailInput: '',
          showEmailInput: ''
        },
        {
          title: 'CC: ',
          inputRef: 'inputTwo',
          emails: [],
          errMsg: '',
          showErrMsg: false,
          emailInput: '',
          showEmailInput: ''
        }
      ],
      errMsgs: []
    }
  },
  methods: {
    open(
      sendCb,
      receivers = [],
      ccs = [],
      subject = 'New Mail',
      content = 'Content to write'
    ) {
      this.emailInputs[0].emails = receivers
      this.emailInputs[1].emails = ccs
      this.mailSubject = subject
      this.mailContent = content
      this.sendCb = sendCb
      if (subject) this.$refs.dialog.open()
    },
    addEmail() {
      this.emails.push({
        value: ''
      })
    },
    emailInputShow(group) {
      group.showEmailInput = !group.showEmailInput
      if (group.showEmailInput) {
        this.$nextTick(_ => {
          this.$refs[group.inputRef][0].$refs.input.focus()
        })
      }
    },
    emailInputChange(value) {
      this.emailErrorMsg = ''
      this.emailErrorVisible = false
    },
    emailInputConfirm(group) {
      const inputValue = group.emailInput
      let hasError = true
      if (!inputValue) {
        group.errMsg = 'email is empty!'
      } else if (!inputValue.match(this.emailReg)) {
        group.errMsg = 'email is invalid!'
      } else if (group.emails.indexOf(inputValue) > -1) {
        group.errMsg = 'email already exists!!'
      } else {
        hasError = false
        group.emails.push(inputValue)
        group.showEmailInput = false
        group.showErrMsg = false
        group.emailInput = ''
      }
      group.showErrMsg = hasError
    },
    emailRemove(email, group) {
      const index = group.emails.indexOf(email)
      if (index !== -1) {
        group.emails.splice(index, 1)
      }
    },
    sendMail(_, done, error) {
      // check recipients
      if (this.emailInputs[0].emails.length === 0) {
        error('no recipients are specified!')
        return
      }
      if (!this.mailSubject || this.mailSubject === '') {
        error('no subject!')
        return
      }
      if (!this.mailContent) {
        error('no content!')
        return
      }
      const mail = {
        recipients: this.emailInputs[0].emails,
        ccs: this.emailInputs[1].emails,
        subject: this.mailSubject,
        content: this.mailContent
      }
      this.sendingMail = true

      promisify(this.sendCb)(mail)
        .then(res => {
          this.$message.success('Email sent!')
          done()
        })
        .catch(err => {
          error(err.toString())
        })
        .finally(() => {
          this.sendingMail = false
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.recipient-container,
.subject {
  .title {
    width: 100px;
    margin-top: 5px;
    font-weight: bolder;
  }

  .emails {
    flex-wrap: wrap;
    width: calc(100% - 100px);
    gap: 10px;

    .el-tag {
      height: 28px;
      text-align: center;
      font-weight: bold;

      @extend .f-r-vc;
    }

    .input-new {
      width: 250px;
    }

    .new-but {
      margin: 0;
      height: 32px !important;
    }
  }
}

.subject {
  .el-input {
    width: calc(100% - 100px);
  }
}

.input-error {
  color: $el-danger-color;
  font-size: $secondary-body-font-size;
  min-height: 15px;
}

.content {
  margin: 10px 0;
}

.email-tag {
  font-size: 15px;
  padding: 15px 10px;
}
</style>
